import { render, staticRenderFns } from "./ReportingPage.vue?vue&type=template&id=30c09228"
import script from "./ReportingPage.vue?vue&type=script&lang=js"
export * from "./ReportingPage.vue?vue&type=script&lang=js"
import style0 from "./ReportingPage.vue?vue&type=style&index=0&id=30c09228&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports